var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 728,
    height: 469.691,
    viewBox: "0 0 728 469.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.16,
    x2: 0,
    y2: 0.646,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0533b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3011 454.466)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2556.225,655.966,2426.47,698.879l26.049,21.709h0L2340.243,838.123l-98.415-84.5-392.847,321.887,3.459.053H1950.3l290.56-238.073,103.754,89.085,157.375-164.75v0l28.116,23.432Z",
    transform: "translate(-4839.552 -1103.068)",
    fill: "#0533b3",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2447.787 -191.917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-366.844,1926.253s-35.221-53.113,0-116.661c0,0,56.932,42.166,36.455,116.661Z",
    transform: "translate(382.498 -1809.592)",
    fill: "#a9dcb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325.982,1882.847c-.041-.378-.082-.757-.127-1.132a156.364,156.364,0,0,1-19.588,23.313c-1.652-13.041-3.846-26.568-6.3-39.444l.029.02a242.657,242.657,0,0,0,13.539-22.229c-.144-.266-.29-.528-.435-.791a241.829,241.829,0,0,1-13.326,21.991c-4.279-22.272-9.313-42.476-13.63-54.654-.274-.215-.426-.328-.426-.328-.1.179-.191.357-.289.536,4.285,12.044,9.289,32.1,13.552,54.248-10.052-7.65-18.717-14.633-26.185-21.108-.062.28-.128.562-.188.841,7.579,6.556,16.371,13.627,26.586,21.384,2.486,13.034,4.706,26.748,6.368,39.955a192.656,192.656,0,0,1-33.352-15.2q.1.5.2.986a193.048,193.048,0,0,0,33.261,15.059c.852,6.856,1.551,13.566,2.055,19.964h.757c-.512-6.5-1.226-13.318-2.1-20.287A153.781,153.781,0,0,0-325.982,1882.847Z",
    transform: "translate(381.899 -1809.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.751,2084.639s20.8-31.362,0-68.883c0,0-33.616,24.9-21.526,68.883Z",
    transform: "translate(497.303 -1967.98)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-451.432,2059.01c.024-.224.048-.447.075-.669a92.323,92.323,0,0,0,11.566,13.766c.976-7.7,2.271-15.688,3.72-23.29l-.017.012a143.215,143.215,0,0,1-7.994-13.126c.085-.157.171-.312.257-.467a142.749,142.749,0,0,0,7.869,12.985c2.526-13.151,5.5-25.081,8.048-32.272.162-.126.251-.193.251-.193.059.105.113.21.171.316-2.53,7.111-5.485,18.952-8,32.032,5.935-4.517,11.052-8.64,15.461-12.464.037.165.076.332.111.5-4.475,3.871-9.666,8.046-15.7,12.626-1.468,7.7-2.779,15.794-3.76,23.592a113.74,113.74,0,0,0,19.693-8.977c-.038.2-.076.389-.116.582a113.948,113.948,0,0,1-19.64,8.892c-.5,4.049-.916,8.011-1.213,11.788h-.447c.3-3.836.724-7.864,1.238-11.978A90.821,90.821,0,0,1-451.432,2059.01Z",
    transform: "translate(492.211 -1967.98)",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.163,0H726.837A1.163,1.163,0,0,1,728,1.163v0a1.164,1.164,0,0,1-1.164,1.164H1.164A1.164,1.164,0,0,1,0,1.163v0A1.163,1.163,0,0,1,1.163,0Z",
    transform: "translate(-3011 -27.505)",
    fill: "#2e3552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3089.481,2116.394v11.444a4.371,4.371,0,0,1-.755,2.462,4.444,4.444,0,0,1-2.07,1.65,4.1,4.1,0,0,1-.807.227,4.276,4.276,0,0,1-.777.071H2902.792a4.425,4.425,0,0,1-4.405-4.184c0-.076,0-.151,0-.227v-11.444c0-.075,0-.151,0-.227a4.425,4.425,0,0,1,4.405-4.183h182.279a4.3,4.3,0,0,1,.777.071,4.087,4.087,0,0,1,.807.227,4.444,4.444,0,0,1,2.07,1.65A4.372,4.372,0,0,1,3089.481,2116.394Z",
    transform: "translate(-5601.177 -2159.804)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2999.972,2132.248h-97.654a4.18,4.18,0,0,1-3.932-4.184c0-.076,0-.151,0-.227v-11.444c0-.075,0-.151,0-.227a4.18,4.18,0,0,1,3.932-4.183h85.662C2989.348,2117.949,2992.537,2126.2,2999.972,2132.248Z",
    transform: "translate(-5601.177 -2159.804)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2535.947 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2542.96 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2551.369 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2564.26 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2577.89 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2598.787 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2529.272 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2524.862 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2520.604 -47.82)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3576.515,2112.054v20.122a4.282,4.282,0,0,1-.778.071h-1.294v-20.264h1.294A4.3,4.3,0,0,1,3576.515,2112.054Z",
    transform: "translate(-6091.843 -2159.804)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3587.011,2114.719v16.369a4.444,4.444,0,0,1-2.07,1.65v-19.669A4.443,4.443,0,0,1,3587.011,2114.719Z",
    transform: "translate(-6099.462 -2160.591)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3018.411,2042.5v11.444a4.363,4.363,0,0,1-.756,2.462,4.433,4.433,0,0,1-2.07,1.651,4.1,4.1,0,0,1-.807.227,4.278,4.278,0,0,1-.777.071H2831.722a4.426,4.426,0,0,1-4.406-4.184c0-.076,0-.151,0-.227V2042.5c0-.075,0-.151,0-.227a4.425,4.425,0,0,1,4.406-4.183H3014c.117,0,.234,0,.348.014.049,0,.1.008.149.015s.11.012.163.021.078.012.117.019a4.08,4.08,0,0,1,.807.227c.039.014.075.029.115.046s.076.031.112.048l.222.107.127.071c.039.022.075.042.112.066.071.041.139.085.207.132s.154.109.227.168.115.09.17.139c0,0,.008,0,.01.009.036.032.075.066.112.1a4.014,4.014,0,0,1,.319.329c.032.034.061.068.089.1s.055.07.084.106c.056.073.113.149.163.225A4.363,4.363,0,0,1,3018.411,2042.5Z",
    transform: "translate(-5549.597 -2106.173)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2928.9,2058.353h-97.654a4.179,4.179,0,0,1-3.933-4.184c0-.076,0-.151,0-.227V2042.5c0-.075,0-.151,0-.227a4.179,4.179,0,0,1,3.933-4.183h85.659c.039.166.078.331.119.5C2918.459,2044.507,2921.669,2052.471,2928.9,2058.353Z",
    transform: "translate(-5549.597 -2106.173)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2555.436 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2562.448 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2570.858 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2583.749 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2597.379 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2618.276 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2637.841 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2655.313 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.761 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2544.351 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2540.093 -68.085)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3505.446,2038.157v20.123a4.347,4.347,0,0,1-.777.071h-1.295v-20.264h1.295A4.3,4.3,0,0,1,3505.446,2038.157Z",
    transform: "translate(-6040.264 -2106.172)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3515.943,2040.822v16.368a4.444,4.444,0,0,1-2.07,1.65v-19.669A4.443,4.443,0,0,1,3515.943,2040.822Z",
    transform: "translate(-6047.883 -2106.959)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3052.755,1970.424v11.444a4.37,4.37,0,0,1-.756,2.462,4.437,4.437,0,0,1-2.07,1.65,4.128,4.128,0,0,1-.808.227,4.347,4.347,0,0,1-.777.07h-182.28a4.373,4.373,0,0,1-2.033-.5,4.433,4.433,0,0,1-2.357-3.487c-.007-.066-.012-.131-.015-.2s-.005-.151-.005-.227v-11.444c0-.075,0-.151.005-.227a4.426,4.426,0,0,1,4.405-4.184h182.28a4.3,4.3,0,0,1,.777.071,4.143,4.143,0,0,1,.808.227,4.443,4.443,0,0,1,2.07,1.651A4.369,4.369,0,0,1,3052.755,1970.424Z",
    transform: "translate(-5574.521 -2053.864)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2963.246,1986.278h-97.654a3.567,3.567,0,0,1-1.814-.5,4.459,4.459,0,0,1-2.1-3.487c-.007-.066-.012-.131-.015-.2s-.005-.151-.005-.227v-11.444c0-.075,0-.151.005-.227a4.181,4.181,0,0,1,3.932-4.184h85.662c1.331,5.8,4.383,13.768,11.393,19.765C2962.843,1985.947,2963.043,1986.112,2963.246,1986.278Z",
    transform: "translate(-5574.521 -2053.864)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2546.018 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2553.031 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2561.44 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2574.331 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2587.961 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2608.858 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2628.423 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2645.894 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2539.343 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2534.933 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2530.674 -87.849)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3539.79,1966.084v20.123a4.347,4.347,0,0,1-.777.071h-1.294v-20.264h1.294A4.347,4.347,0,0,1,3539.79,1966.084Z",
    transform: "translate(-6065.189 -2053.864)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550.288,1968.749v16.368a4.444,4.444,0,0,1-2.07,1.651V1967.1A4.436,4.436,0,0,1,3550.288,1968.749Z",
    transform: "translate(-6072.81 -2054.65)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3068.677,1896.53v11.443a4.37,4.37,0,0,1-.756,2.463,4.439,4.439,0,0,1-2.07,1.65,4.144,4.144,0,0,1-.807.227,4.33,4.33,0,0,1-.778.07h-182.28a4.425,4.425,0,0,1-4.405-4.183c0-.076-.005-.151-.005-.227V1896.53c0-.076,0-.151.005-.227a4.425,4.425,0,0,1,3.884-4.151,4.032,4.032,0,0,1,.522-.032h182.28a4.308,4.308,0,0,1,.778.071,4.16,4.16,0,0,1,.807.226,4.443,4.443,0,0,1,2.07,1.651A4.37,4.37,0,0,1,3068.677,1896.53Z",
    transform: "translate(-5586.077 -2000.233)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2979.168,1912.383h-97.654a4.18,4.18,0,0,1-3.933-4.183c0-.076-.005-.151-.005-.227V1896.53c0-.076,0-.151.005-.227a4.252,4.252,0,0,1,3.467-4.151,3.207,3.207,0,0,1,.466-.032h85.661c0,.01,0,.022.007.032C2968.555,1898.112,2971.744,1906.344,2979.168,1912.383Z",
    transform: "translate(-5586.077 -2000.233)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2541.652 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.665 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2557.074 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2569.965 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2583.595 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2604.491 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2624.056 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2641.529 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2534.977 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2530.567 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2526.309 -108.114)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3555.712,1892.187v20.123a4.341,4.341,0,0,1-.777.071h-1.295v-20.264h1.295A4.341,4.341,0,0,1,3555.712,1892.187Z",
    transform: "translate(-6076.745 -2000.231)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3566.209,1894.852v16.368a4.442,4.442,0,0,1-2.069,1.651V1893.2A4.442,4.442,0,0,1,3566.209,1894.852Z",
    transform: "translate(-6084.366 -2001.018)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3019.808,1822.75v11.444a4.365,4.365,0,0,1-.756,2.462,4.435,4.435,0,0,1-2.07,1.651,4.084,4.084,0,0,1-.807.227c-.085.015-.171.029-.256.039l-.145.015c-.046,0-.095.007-.144.01-.078,0-.156.008-.233.008h-182.28a4.426,4.426,0,0,1-4.405-4.184c0-.076-.005-.151-.005-.227V1822.75c0-.076,0-.151.005-.227s.007-.124.013-.185a4.434,4.434,0,0,1,3.306-3.862c.043-.013.09-.022.134-.032a4.431,4.431,0,0,1,.953-.1H3015.4c.134,0,.265.008.395.017.059.007.117.012.176.02h0c.068.009.137.022.205.034a4.1,4.1,0,0,1,.807.227,4.436,4.436,0,0,1,2.07,1.65A4.365,4.365,0,0,1,3019.808,1822.75Z",
    transform: "translate(-5550.609 -1946.685)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2930.3,1838.6h-97.654a4.18,4.18,0,0,1-3.933-4.184c0-.076-.005-.151-.005-.227V1822.75c0-.076,0-.151.005-.227s.007-.124.013-.185a4.293,4.293,0,0,1,3.054-3.888,1.256,1.256,0,0,1,.168-.04,3.475,3.475,0,0,1,.7-.071h85.662c.01.049.021.1.034.145,1.382,5.944,4.571,14.091,11.918,20.088Z",
    transform: "translate(-5550.609 -1946.685)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2555.053 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2562.066 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2570.476 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2583.365 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2596.996 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2617.893 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2637.458 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2654.929 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.378 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2543.968 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2539.71 -128.346)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3506.843,1818.408v20.123a4.282,4.282,0,0,1-.778.071h-1.294v-20.264h1.294A4.3,4.3,0,0,1,3506.843,1818.408Z",
    transform: "translate(-6041.278 -1946.684)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3517.34,1821.073v16.368a4.442,4.442,0,0,1-2.069,1.651v-19.669A4.442,4.442,0,0,1,3517.34,1821.073Z",
    transform: "translate(-6048.897 -1947.471)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3018.411,1749.38v11.444a4.366,4.366,0,0,1-.756,2.462,4.438,4.438,0,0,1-2.07,1.651,3.976,3.976,0,0,1-.629.19h0c-.059.015-.115.027-.174.037a4.3,4.3,0,0,1-.777.071H2831.722a4,4,0,0,1-.571-.039,1.961,1.961,0,0,1-.217-.034,4.425,4.425,0,0,1-3.618-4.111c0-.075,0-.151,0-.227V1749.38c0-.075,0-.151,0-.227a4.425,4.425,0,0,1,4.406-4.184H3014c.117,0,.234.005.348.015l.149.015c.053.005.11.012.163.022s.078.012.117.02a4.079,4.079,0,0,1,.807.227c.039.015.075.029.115.046s.076.031.112.049c.076.034.149.07.222.107s.161.088.239.136.139.086.207.132.154.109.227.168.115.09.17.139a.047.047,0,0,1,.01.01c.036.031.075.066.112.1a4.023,4.023,0,0,1,.319.33c.032.034.061.068.089.1l.084.107c.056.073.113.149.163.224A4.364,4.364,0,0,1,3018.411,1749.38Z",
    transform: "translate(-5549.597 -1893.435)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2928.9,1765.234h-97.654c-.078,0-.156,0-.232-.007s-.169-.015-.251-.027a4.252,4.252,0,0,1-3.45-4.15c0-.075,0-.151,0-.227V1749.38c0-.075,0-.151,0-.227a4.179,4.179,0,0,1,3.933-4.184h85.659c.039.166.078.332.119.5,1.419,5.871,4.591,13.753,11.7,19.62Z",
    transform: "translate(-5549.597 -1893.435)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2555.436 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2562.448 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2570.858 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2583.749 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2597.379 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2618.276 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2637.841 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2655.313 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.761 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2544.351 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2540.093 -148.465)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3505.446,1745.041v20.123a4.3,4.3,0,0,1-.777.071h-1.295V1744.97h1.295A4.3,4.3,0,0,1,3505.446,1745.041Z",
    transform: "translate(-6040.264 -1893.436)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3515.943,1747.707v16.368a4.446,4.446,0,0,1-2.07,1.651v-19.669A4.436,4.436,0,0,1,3515.943,1747.707Z",
    transform: "translate(-6047.883 -1894.224)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3052.755,1677.307v11.443a4.371,4.371,0,0,1-.756,2.463,4.444,4.444,0,0,1-2.07,1.651,4.126,4.126,0,0,1-.808.227,4.313,4.313,0,0,1-.777.071h-182.28a4.371,4.371,0,0,1-2.033-.5,4.432,4.432,0,0,1-2.357-3.486c-.007-.066-.012-.132-.015-.2s-.005-.151-.005-.227v-11.443c0-.076,0-.151.005-.226a4.426,4.426,0,0,1,4.405-4.184h182.28a4.28,4.28,0,0,1,.777.071,4.118,4.118,0,0,1,.808.227,4.441,4.441,0,0,1,2.07,1.65A4.371,4.371,0,0,1,3052.755,1677.307Z",
    transform: "translate(-5574.521 -1841.128)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2963.246,1693.161h-97.654a3.566,3.566,0,0,1-1.814-.5,4.458,4.458,0,0,1-2.1-3.486c-.007-.066-.012-.132-.015-.2s-.005-.151-.005-.227v-11.443c0-.076,0-.151.005-.226a4.181,4.181,0,0,1,3.932-4.184h85.662c1.331,5.8,4.383,13.767,11.393,19.764C2962.843,1692.83,2963.043,1693,2963.246,1693.161Z",
    transform: "translate(-5574.521 -1841.128)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2546.018 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2553.031 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2561.44 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2574.331 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2587.961 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2608.858 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2628.423 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2645.894 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2539.343 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2534.933 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2530.674 -168.229)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3539.79,1672.969v20.123a4.3,4.3,0,0,1-.777.071h-1.294V1672.9h1.294A4.335,4.335,0,0,1,3539.79,1672.969Z",
    transform: "translate(-6065.189 -1841.128)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550.288,1675.633V1692a4.437,4.437,0,0,1-2.07,1.65v-19.669A4.434,4.434,0,0,1,3550.288,1675.633Z",
    transform: "translate(-6072.81 -1841.916)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3107.075,1603.411v11.444a4.365,4.365,0,0,1-.756,2.462,4.439,4.439,0,0,1-2.07,1.651,4.108,4.108,0,0,1-.807.227,4.291,4.291,0,0,1-.777.071h-182.28a4.426,4.426,0,0,1-4.406-4.183c0-.076,0-.152,0-.227v-11.444c0-.075,0-.151,0-.227a4.429,4.429,0,0,1,3.883-4.152,4.1,4.1,0,0,1,.522-.032h182.28a4.28,4.28,0,0,1,.777.071,4.115,4.115,0,0,1,.807.227,4.44,4.44,0,0,1,2.07,1.651A4.365,4.365,0,0,1,3107.075,1603.411Z",
    transform: "translate(-5613.945 -1787.496)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3017.566,1619.265h-97.654a4.181,4.181,0,0,1-3.933-4.183c0-.076,0-.152,0-.227v-11.444c0-.075,0-.151,0-.227a4.254,4.254,0,0,1,3.467-4.152,3.23,3.23,0,0,1,.466-.032h85.661c0,.01.005.022.007.032C3006.954,1605,3010.143,1613.227,3017.566,1619.265Z",
    transform: "translate(-5613.945 -1787.496)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2531.122 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2538.135 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2546.544 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2559.434 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2573.064 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2593.961 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2613.527 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2630.997 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2524.447 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2520.036 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2515.779 -188.494)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3594.112,1599.072v20.123a4.312,4.312,0,0,1-.778.071h-1.295V1599h1.295A4.323,4.323,0,0,1,3594.112,1599.072Z",
    transform: "translate(-6104.614 -1787.496)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3604.609,1601.737V1618.1a4.446,4.446,0,0,1-2.07,1.651v-19.669A4.443,4.443,0,0,1,3604.609,1601.737Z",
    transform: "translate(-6112.235 -1788.283)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3019.808,1529.632v11.444a4.367,4.367,0,0,1-.756,2.463,4.444,4.444,0,0,1-2.07,1.651,4.142,4.142,0,0,1-.807.227c-.085.014-.171.029-.256.039-.068.01-.137.015-.205.02l-.1.007c-.07,0-.141,0-.214,0h-182.28a4.426,4.426,0,0,1-4.405-4.183c0-.076-.005-.151-.005-.227v-11.444c0-.075,0-.151.005-.226a4.426,4.426,0,0,1,4.405-4.184H3015.4c.077,0,.156,0,.233.007a4.4,4.4,0,0,1,.544.064,4.117,4.117,0,0,1,.807.227,3.852,3.852,0,0,1,.383.171c.078.039.153.078.227.122a.07.07,0,0,1,.024.015c.076.044.149.09.222.139a.2.2,0,0,1,.037.024,2.308,2.308,0,0,1,.2.144,3.891,3.891,0,0,1,.439.383c.043.042.084.085.124.129.006.007.015.015.022.024.026.027.051.054.076.083,0,0,.009.013.014.017.044.051.088.105.129.161.061.078.119.156.175.239A4.367,4.367,0,0,1,3019.808,1529.632Z",
    transform: "translate(-5550.609 -1733.949)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2930.3,1545.486h-97.654a4.18,4.18,0,0,1-3.933-4.183c0-.076-.005-.151-.005-.227v-11.444c0-.075,0-.151.005-.226a4.18,4.18,0,0,1,3.933-4.184h85.662c.034.154.07.31.112.468,1.421,5.912,4.625,13.874,11.84,19.764Z",
    transform: "translate(-5550.609 -1733.949)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2555.053 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2562.066 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2570.476 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2583.365 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2596.996 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2617.893 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2637.458 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2654.929 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2548.378 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.265,
    transform: "translate(-2543.968 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.265,
    transform: "translate(-2539.71 -208.727)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3506.843,1525.293v20.123a4.282,4.282,0,0,1-.778.071h-1.294v-20.264h1.294A4.292,4.292,0,0,1,3506.843,1525.293Z",
    transform: "translate(-6041.278 -1733.949)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3517.34,1527.957v16.368a4.44,4.44,0,0,1-2.069,1.651v-19.669A4.436,4.436,0,0,1,3517.34,1527.957Z",
    transform: "translate(-6048.897 -1734.737)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3068.677,1457.444v11.444a4.37,4.37,0,0,1-.756,2.462,4.439,4.439,0,0,1-2.07,1.651,4.161,4.161,0,0,1-.807.227,4.353,4.353,0,0,1-.778.071h-182.28a4.35,4.35,0,0,1-1.97-.468,4.426,4.426,0,0,1-2.424-3.535c0-.058-.009-.119-.012-.18s-.005-.151-.005-.226v-11.444c0-.076,0-.151.005-.227a4.426,4.426,0,0,1,3.884-4.151,4.076,4.076,0,0,1,.522-.032h182.28a4.286,4.286,0,0,1,.778.071,4.142,4.142,0,0,1,.807.226,4.445,4.445,0,0,1,2.07,1.651A4.372,4.372,0,0,1,3068.677,1457.444Z",
    transform: "translate(-5586.077 -1681.557)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2979.168,1473.3h-97.654a3.545,3.545,0,0,1-1.758-.468,4.452,4.452,0,0,1-2.163-3.535c0-.058-.009-.119-.012-.18s-.005-.151-.005-.226v-11.444c0-.076,0-.151.005-.227a4.253,4.253,0,0,1,3.467-4.151,3.242,3.242,0,0,1,.466-.032h85.661c0,.01,0,.022.007.032,1.336,5.81,4.4,13.774,11.424,19.764C2978.79,1472.989,2978.978,1473.145,2979.168,1473.3Z",
    transform: "translate(-5586.077 -1681.557)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2541.652 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.665 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2557.074 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2569.965 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2583.595 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2604.491 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2534.977 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2530.567 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2526.309 -228.523)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3555.712,1453.1v20.122a4.264,4.264,0,0,1-.777.071h-1.295v-20.264h1.295A4.253,4.253,0,0,1,3555.712,1453.1Z",
    transform: "translate(-6076.745 -1681.556)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3566.209,1455.767v16.369a4.436,4.436,0,0,1-2.069,1.65v-19.669A4.436,4.436,0,0,1,3566.209,1455.767Z",
    transform: "translate(-6084.366 -1682.343)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3019.808,1383.664v11.444a4.366,4.366,0,0,1-.756,2.462,4.441,4.441,0,0,1-2.07,1.651,4.134,4.134,0,0,1-.807.227c-.085.015-.171.029-.256.039l-.145.014c-.046.005-.095.007-.144.01-.078,0-.156.008-.233.008h-182.28a4.426,4.426,0,0,1-4.405-4.184c0-.076-.005-.152-.005-.227v-11.444c0-.075,0-.151.005-.227a4.426,4.426,0,0,1,4.405-4.184H3015.4a4.314,4.314,0,0,1,.777.071,4.118,4.118,0,0,1,.807.227,4.44,4.44,0,0,1,2.07,1.651A4.365,4.365,0,0,1,3019.808,1383.664Z",
    transform: "translate(-5550.609 -1628.009)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2930.3,1399.518h-97.654a4.18,4.18,0,0,1-3.933-4.184c0-.076-.005-.152-.005-.227v-11.444c0-.075,0-.151.005-.227a4.18,4.18,0,0,1,3.933-4.184h85.662c1.365,5.956,4.544,14.187,11.953,20.233Z",
    transform: "translate(-5550.609 -1628.009)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2555.053 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2562.066 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2570.476 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2583.365 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2596.996 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2617.893 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2548.378 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.072,
    height: 20.264,
    transform: "translate(-2543.968 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.071,
    height: 20.264,
    transform: "translate(-2539.71 -248.755)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3506.843,1379.323v20.123a4.326,4.326,0,0,1-.778.071h-1.294v-20.265h1.294A4.337,4.337,0,0,1,3506.843,1379.323Z",
    transform: "translate(-6041.278 -1628.008)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3517.34,1381.988v16.368a4.442,4.442,0,0,1-2.069,1.651v-19.669A4.44,4.44,0,0,1,3517.34,1381.988Z",
    transform: "translate(-6048.897 -1628.796)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.162,
    cy: 103.162,
    r: 103.162,
    transform: "translate(-2844.189 -130.667) rotate(-45)",
    fill: "#e2810e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.162,
    cy: 103.162,
    r: 103.162,
    transform: "translate(-2853.188 -130.667) rotate(-45)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2633.213,1659.556a93.991,93.991,0,1,1,66.462-27.529A93.377,93.377,0,0,1,2633.213,1659.556Zm0-182.376a88.384,88.384,0,1,0,62.5,25.887A87.806,87.806,0,0,0,2633.213,1477.18Z",
    transform: "translate(-5340.509 -1695.012)",
    fill: "#ffa412",
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3841.224,2055.873a45.969,45.969,0,0,0,45.969-45.969h-91.938A45.969,45.969,0,0,0,3841.224,2055.873Z",
    transform: "translate(-6252.103 -2085.718)",
    fill: "#222f3e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3867.363,2055.521a46,46,0,0,1-51.678-45.617h11.42A45.977,45.977,0,0,0,3867.363,2055.521Z",
    transform: "translate(-6266.93 -2085.717)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3886.147,2171.055h-93.208a5.671,5.671,0,0,1,5.671-5.671h81.865a5.671,5.671,0,0,1,5.671,5.671Z",
    transform: "translate(-6250.421 -2198.561)",
    fill: "#222f3e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94.495,
    height: 1.41,
    transform: "translate(-2458.359 -75.814)",
    fill: "#222f3e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2489.765,810.477l.015,2.787s-.76,8.717,9.975,9.99,19.536,1.109,19.245-5.618c-.967-5.208-2.7-13.292-2.771-17.6a30.3,30.3,0,0,1,.382-5.22l-20.8-.415-6.126,1Z",
    transform: "translate(-5304.557 -1203.538)",
    fill: "#ffb27d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2489.686,795.4l.079,15.077a17.593,17.593,0,0,0,7.5,1.654c9.559,0,15.737-7.01,18.967-12.1a30.3,30.3,0,0,1,.382-5.22l-20.8-.415Z",
    transform: "translate(-5304.557 -1203.538)",
    fill: "#e2915a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2502.81,697.141c-2.412,12.988-19.171,12.561-26.413,11.745-2.038-.227-3.321-.487-3.321-.487-2.3-.614-3.58-4.234-4.176-8.975-1.182-9.383.311-23.156,1.9-26.68,2.385-5.3,6.879-11.034,23.755-6.9S2505.907,680.5,2502.81,697.141Z",
    transform: "translate(-5289.163 -1109.212)",
    fill: "#ffb27d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.838,2147.423h-23.746a57.36,57.36,0,0,1,1.893-8.524,24.268,24.268,0,0,1,1.345-3.421c2.309-4.61,16.979-1.678,16.979-1.678s1.362,1.167,2.426,5.626A47.292,47.292,0,0,1,2580.838,2147.423Z",
    transform: "translate(-5353.478 -2174.971)",
    fill: "#222f3e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2253.345,2114.348c-.065,3.231-.472,6.289-1.644,7.495h-46.97c.6-1.7,2.287-4.255,7.109-5.038,5.48-.887,14.021-3.524,19.008-8.8a14.152,14.152,0,0,0,3.68-6.664c2.209-9.839,18.272,3.014,18.272,3.014A79.589,79.589,0,0,1,2253.345,2114.348Z",
    transform: "translate(-5097.745 -2149.391)",
    fill: "#222f3e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2351.1,1453.67a74,74,0,0,0-1.179,8.677c-1.493,29.126-24.517,95.722-28.635,97.274-6.372,2.4-16.407-2.706-21.656-4.379a4.5,4.5,0,0,1-3.16-5.114c11.4-52.418,15.592-127.9,17.117-172.584.771-22.508,4.634-38.057,4.634-38.057s56.156-14.983,56.489,3.97C2375.007,1360.228,2356.11,1426,2351.1,1453.67Z",
    transform: "translate(-5164.26 -1595.067)",
    fill: "#0533b3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2396.649,1453.67l-37.513-76.127c.77-22.508,4.634-38.057,4.634-38.057s56.156-14.983,56.489,3.97C2420.554,1360.228,2401.656,1426,2396.649,1453.67Z",
    transform: "translate(-5209.807 -1595.067)",
    fill: "url(#a)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2450.37,1350.97l29.686,215.156s13.037,3.144,23.176.628c0,0,8.691-114.429,7.967-142.094s6.237-74.024-1.589-79.137S2450.37,1350.97,2450.37,1350.97Z",
    transform: "translate(-5276.022 -1602.514)",
    fill: "#0533b3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2457.609,634.748a55.821,55.821,0,0,0,16.19-4.381c7.111-3.092,16.083.313,19,1.848a4.329,4.329,0,0,0-.71-1.752,3.907,3.907,0,0,1,1.5,2.223c.135.1.2.168.16.191a5.015,5.015,0,0,1,2.435.157s-.667-.1-.9.333a.4.4,0,0,1-.107.118c11.094,5.36,12.117,22.891,8.548,26.948-4.3,4.881-9.445,15.871-9.445,15.871a9.419,9.419,0,0,1-1.1-6.891c.781-4.295-2.929-4.295-7.614-6.247s-.781-7.418-4.88-10.737-19.132-1.366-18.937-3.9C2456.164,646.492,2457.609,635.32,2457.609,634.748Z",
    transform: "translate(-5281.155 -1083.578)",
    fill: "#222f3e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2440.971,892.765l-6.835,146.649s-57.044.932-55.416-11.977,20.562-130.182,20.562-130.182l41.689-4.491Z",
    transform: "translate(-5223.997 -1274.93)",
    fill: "#e9f3fe"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2576.415,961.455c-3.394,10.181,3,44.344,5.286,55.917.5,2.448.835,3.894.835,3.894-7.9,12.852-36.833,12.686-36.833,12.686-5.564-24.593-8.457-63.762-8.457-63.762l22.2-97.314,27.931,25.817s-2.114,15.746-4.73,31.77C2580.588,943.15,2578.251,956.058,2576.415,961.455Z",
    transform: "translate(-5339.074 -1260.496)",
    fill: "#0533b3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2485.607,787.4s-.542,1.675-4.77,1.064c0,0-3.55-.513-3.286-2.381A11.517,11.517,0,0,1,2485.607,787.4Z",
    transform: "translate(-5295.739 -1197.33)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2263.745,881.208l-.013.062c-1.35,1.308-39.43,38.281-46.808,52.763-7.512,14.69,34.329,43.954,34.329,43.954a9.742,9.742,0,0,0,4.561.648c-1.972,16.242-4.187,31.229-2.875,37.626,2.371,11.562,13.065,15.444,13.065,14.555,0-.283,2.756-42.159,6.036-63.79,7.28-48.009,15.963-93.066,15.963-93.066C2275.552,875.254,2263.745,881.208,2263.745,881.208Zm-22.674,59.168a.339.339,0,0,1-.055-.222c0-2.115,8.068-6.789,16.8-12.3l.167-.168.017-.011c-.156,4.5-.139,8.915.129,13.025.5,7.623-.058,16.734-.981,26.011C2252.992,960.219,2241.884,942.768,2241.071,940.375Z",
    transform: "translate(-5105.939 -1261.282)",
    fill: "#0533b3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2541.185,863.418c.069-1.4-6.56-3.333-6.56-3.333s-7.587,10.52-20.088,10.7c0,0,3.562,6.933,7.761,8.728C2522.3,879.514,2540.772,871.729,2541.185,863.418Z",
    transform: "translate(-5322.593 -1251.211)",
    fill: "#d9e9f9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2449.085,1003.343a13.84,13.84,0,0,0,4.408,8.947l3.978,3.665a2.329,2.329,0,0,0,3.408-.274l4.927-6.257a8.31,8.31,0,0,0,1.741-5.927c-.461-4.734-1.32-13.857-2.007-22.662-.559-7.134-1.008-14.065-1.041-18.281-.108-13.462,2.563-56.391,2.563-56.391l-3.227.168a172.831,172.831,0,0,0-12.212,39.337,149.906,149.906,0,0,0-2.231,17.675S2447.708,987.862,2449.085,1003.343Z",
    transform: "translate(-5274.697 -1284.653)",
    fill: "#f9ae30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2449.085,1107.9a13.84,13.84,0,0,0,4.408,8.947l3.978,3.665a2.329,2.329,0,0,0,3.408-.274l4.927-6.257a8.31,8.31,0,0,0,1.741-5.927c-.461-4.734-1.32-13.857-2.007-22.663-8.919-10.02-12.532-23.867-13.918-35.167a149.911,149.911,0,0,0-2.231,17.675S2447.708,1092.416,2449.085,1107.9Z",
    transform: "translate(-5274.697 -1389.208)",
    fill: "#f9ae30"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2479.185,876.394s-6.622-3.926-6.645-8.182c0,0-4.277-.536-6.145,1.539,0,0-1.571,7.294.512,11.53C2466.906,881.282,2476.443,879.829,2479.185,876.394Z",
    transform: "translate(-5287.241 -1257.065)",
    fill: "#d9e9f9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2504.143,890.214l-8.98-2.152a1.361,1.361,0,0,0-1.141,1.565c.033,1.463,2.529,5.737,3.635,6.078S2506.267,893.174,2504.143,890.214Z",
    transform: "translate(-5307.704 -1271.516)",
    fill: "#f9ae30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2540.139,858.269c.069-1.4-4.417-4.283-4.417-4.283s-8.684,10.15-21.185,10.331c0,0,3.562,6.933,7.761,8.728C2522.3,873.046,2539.726,866.58,2540.139,858.269Z",
    transform: "translate(-5322.593 -1246.785)",
    fill: "#e9f3fe"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2479.324,871s-6.7-3.55-6.72-7.806c0,0-4.042,1.779-5.911,3.853a12.287,12.287,0,0,0,.353,8.841S2476.583,874.434,2479.324,871Z",
    transform: "translate(-5287.38 -1253.467)",
    fill: "#e9f3fe"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2334.769,1245.46a6.173,6.173,0,0,1,6.982-6.177,3.819,3.819,0,0,1,2.594,1.432c2.543,3.385,4.962,13.235.457,13.7-1.834.188-4.191-1.1-6.005-2.478-1.844-1.4-4.027-3.595-4.027-5.911Z",
    transform: "translate(-5192.123 -1526.373)",
    fill: "#ffb27d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2641.6,1169.783c-8.179-8.513-22.312-25.26-21.811-39,.667-19.251,22.756-47.9,22.756-47.9-2.059,12.686-4.4,25.594-6.231,30.991C2632.919,1124.046,2639.317,1158.209,2641.6,1169.783Z",
    transform: "translate(-5398.973 -1412.905)",
    fill: "url(#b)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2630.95,1277.687s-5.88,2.94-9.45,1.47-7.769-2.574-11.759,1.968-4.829,7.691-3.99,9.371,10.142,1.05,11.686,0,3.985-3.634,5.533-3.184c4.272,1.242,7.871-2.018,9.885-4.613C2634.071,1281.133,2630.792,1280.374,2630.95,1277.687Z",
    transform: "translate(-5388.58 -1554.295)",
    fill: "#ffb27d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2618.2,872.877s23.418,2.592,28.942,12.791,34.242,51.529,33.3,68.705-39.176,36.437-39.176,36.437-8.468-3.578-8.595-7.428,26.433-26.861,24.823-31.155-30.856-38.258-33.678-49.456S2618.2,872.877,2618.2,872.877Z",
    transform: "translate(-5397.828 -1260.496)",
    fill: "#0533b3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2323.911,1042.041l-.167.168c-8.735,5.507-16.8,10.181-16.8,12.3-1.168-3.729,10.182-19.308,13.855-22.479C2324.523,1028.8,2323.911,1042.041,2323.911,1042.041Z",
    transform: "translate(-5171.865 -1375.635)",
    fill: "url(#b)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2551.416,853.986s-17.779,74.464-14.95,102.515c0,0,6.538-29.975,22.268-54.528,0,0-5.741-5.048-5.429-6.91a19.65,19.65,0,0,1,8.4-.413s-.457-32.1-3.035-35.489S2551.416,853.986,2551.416,853.986Z",
    transform: "translate(-5338.287 -1246.785)",
    fill: "url(#b)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2439.423,863.193c.241.113-17.619,72.764-19.122,96.019,0,0,1.781-41.5,1.606-53.457,0,0,7.384-3.909,7.384-5.281s-7.877-5.08-7.877-5.08,4.988-25.555,7.711-28.371S2439.423,863.193,2439.423,863.193Z",
    transform: "translate(-5254.2 -1253.467)",
    fill: "url(#b)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3209.485,1262.346l48.685-.057a11.555,11.555,0,0,0,11.507-11.534l-.025-21.1a11.554,11.554,0,0,0-11.533-11.507l-48.686.057a11.554,11.554,0,0,0-11.507,11.534l.024,21.1A11.554,11.554,0,0,0,3209.485,1262.346Z",
    transform: "translate(-5818.578 -1511.085)",
    fill: "url(#b)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3244.709,1200.674v0a11.606,11.606,0,0,0-8.9-5.768h0a.009.009,0,0,1-.008,0c-.373-.035-.749-.056-1.132-.055l-9.694.013-.006-4.553a3.819,3.819,0,0,0-3.82-3.81l-2.529,0-10.179.012-1.835,0a3.819,3.819,0,0,0-3.81,3.82l.005,4.553-16.733.018a11.6,11.6,0,0,0-11.551,11.576l.027,21.344a11.6,11.6,0,0,0,11.576,11.549l48.6-.054a11.317,11.317,0,0,0,2.5-.279h.008a11.382,11.382,0,0,0,3.582-1.473,11.587,11.587,0,0,0,5.465-9.827l-.024-21.341A11.468,11.468,0,0,0,3244.709,1200.674Zm-39.522-10.344a1.429,1.429,0,0,1,1-1.36,1.469,1.469,0,0,1,.423-.066l2.162,0,8.011-.007,4.368-.005a1.425,1.425,0,0,1,1.425,1.421l.006,4.553-17.39.018Z",
    transform: "translate(-5801.588 -1488.112)",
    fill: "#222f3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCoins);
export default __webpack_public_path__ + "static/media/crypto-coins.c464f26163ab2661c694491b49ffd843.svg";
export { ForwardRef as ReactComponent };